<ng-container *ngIf="content">
  <ng-container *ngIf="showContent">
    <div *ngIf="content.title" edsRow>
      <div edsCol>
        <eds-section-title
          [theme]="titleColorTheme"
          [preTitle]="content.preTitle"
          [title]="content.title"
          [subTitle]="content?.subTitle"
        ></eds-section-title>
      </div>
    </div>

    <div *ngIf="content.summary" edsRow [edsSpacing]="showCta ? 'lg' : 'none'">
      <div edsCol *ngIf="content.summary" [innerHTML]="content.summary"></div>
    </div>
  </ng-container>

  <ng-container *ngIf="showCta && content.link?.displayText">
    <ng-container *ngTemplateOutlet="cta"></ng-container>
  </ng-container>

  <!-- Display CTA Button -->
  <ng-template #cta>
    <div edsRow edsPadding edsPaddingTop="lg">
      <div edsCol>
        <a
          edsButton="primary"
          [attr.data-signin-required]="content.link.signInLink"
          [href]="content.link.url"
          [target]="content.link.target"
          [title]="content.link.title"
          [ngClass]="{ 'external-link': content.link.external }"
          (click)="onLinkClicked()"
        >
          {{ content.link.displayText }}
          <eds-icon
            *ngIf="
              content.link.signInLink && !content.link.hideLockIcon
                | ftIsSignInRequired
                | async
            "
            edsPadding
            edsPaddingLeft="xs"
            edsTooltip
            tooltipType="medium"
            [tooltipContent]="'common.locked-link-tooltip' | translate"
            tooltipPositionDefault="top"
            tooltipBehavior="fixed"
            size="small"
            type="lock"
          ></eds-icon>
        </a>
      </div>
    </div>
  </ng-template>
  <!-- / Display CTA Button -->
</ng-container>
